<template lang="pug">
div.field.is-fullwidth
  h3 {{question.text}}
  section(v-if='question.response_type == "Boolean"')
    .control.padded
      .select.is-fullwidth
        select(v-model='question.response.response')
          option(value='true', :selected='question.default_response == "true"') Yes
          option(value='false', :selected='question.default_response == "false"') No
    div(v-if='question.yes && question.response.response == "true"').has-text-link.response-message
      p {{question.yes}}
    div(v-if='question.no && question.response.response == "false"').has-text-link.response-message
      p {{question.no}}
  section(v-else)
    .control.padded
      textarea.textarea(v-model='question.response.response', placeholder='Enter your response')
  hr

</template>

<script>
export default {
  name: "OpenQuestion",
  props: {
    question: null
  }
};
</script>

<style scoped lang="less">
h3 {
  text-align: left;
  padding-left: 0.5rem;
}

.response-message {
  margin: 0.5rem;
  padding: 0.5rem;
  text-align: left;
}
</style>